import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Button, Text, useToast, VStack } from "@chakra-ui/react";
import { useState } from "react";
import type { PaymentMethod } from "@stripe/stripe-js";

interface BillingFormProps {
  onBillingSave: (payment_method: PaymentMethod) => Promise<void>;
  isSaving: boolean;
}

export const BillingForm: React.FC<BillingFormProps> = ({
  onBillingSave,
  isSaving,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const toast = useToast();

  const [isComplete, setIsComplete] = useState(false);

  const handleSave = async () => {
    if (!stripe || !elements) {
      toast({
        title: "Stripe not ready",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      toast({
        title: "Payment error",
        description: submitError.message,
        status: "error",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
      elements: elements,
    });

    if (pmError) {
      toast({
        title: "Payment error",
        description: pmError.message,
        status: "error",
        duration: 6000,
        isClosable: true,
      });
      return;
    }
    console.log("paymentMethod: ", paymentMethod);

    await onBillingSave(paymentMethod);
  };

  return (
    <VStack w="full" align="start" spacing={4}>
      <PaymentElement
        onChange={(event) => setIsComplete((event as any).complete)}
        options={{
          layout: {
            type: "accordion",
            defaultCollapsed: true,
          },
        }}
      />
      <VStack spacing={2} w="full">
        <Button
          colorScheme="green"
          onClick={handleSave}
          isDisabled={isSaving || !stripe || !isComplete}
          isLoading={isSaving}
          alignSelf="flex-start"
          w="full"
        >
          Save Payment Method
        </Button>
        <Text w="full" textAlign={"center"} fontSize="xs" color="gray.500">
          You will be charged in USD
        </Text>
      </VStack>
    </VStack>
  );
};
